import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé todo mi año de telas en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
  name: 'Florencia M.',
  initials: 'FM',
  city: 'Buenos Aires',
  role: 'Profe de Telas en Estudio Propio'
}, {
  quote: 'Las clases con progresión real por nivel cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
  name: 'Camila R.',
  initials: 'CR',
  city: 'Rosario',
  role: 'Profe de Telas en Centro Deportivo'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mezclado.',
  name: 'Valentina F.',
  initials: 'VF',
  city: 'Córdoba',
  role: 'Profe de Telas Grupal e Individual'
}];
export const TestimonialsInitial: React.FC = () => {
  return <section className="py-8 md:py-16 bg-gray-50" data-id="element-435">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-436">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-437">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-5 md:p-8 rounded-xl md:rounded-2xl border border-gray-100 shadow-md hover:shadow-lg transition-shadow relative overflow-hidden border-l-4 border-l-primary" data-id="element-438">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-primary/5 w-12 h-12 md:w-16 md:h-16" data-id="element-439" />

              <div className="flex gap-1 text-yellow-400 mb-3 md:mb-4 relative z-10" data-id="element-440">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-441" />)}
              </div>

              <p className="text-sm md:text-base text-gray-700 italic mb-6 md:mb-8 relative z-10 leading-relaxed min-h-[80px]" data-id="element-442">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto pt-4 border-t border-gray-100 flex items-center gap-3 md:gap-4 relative z-10" data-id="element-443">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary text-white flex items-center justify-center font-bold font-serif text-sm md:text-base flex-shrink-0 shadow-inner" data-id="element-444">
                  {testimonial.initials}
                </div>
                <div data-id="element-445">
                  <p className="font-bold text-gray-900 text-sm md:text-base leading-tight" data-id="element-446">
                    {testimonial.name}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-gray-500 mt-0.5 mb-0.5" data-id="element-447">
                    <span className="text-[10px]" data-id="element-448">📍</span> {testimonial.city}
                  </div>
                  <p className="text-[10px] md:text-xs font-medium text-primary uppercase tracking-wide" data-id="element-449">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};